module.exports = __webpack_public_path__ + "img/pic8.7819491a.png";